module.exports = {
  title: 'Deadline',
  logo: '',
  url: 'https://redq.inc',
  favicon: '../common/static/favicon/favicon.png',
  cover: '',
  legalName: 'RedQ Inc',
  description: 'React Gatsby Coming soon template',
  socialLinks: {
    twitter: '',
    github: '',
    linkedin: '',
    instagram: '',
    youtube: '',
    google: '',
  },
  themeColor: '#000696',
  backgroundColor: '#6496f6',
  social: {
    facebook: '',
    twitter: '',
  },
  address: {
    city: '',
    region: '',
    country: '',
    zipCode: '',
  },
  contact: {
    email: '',
    phone: '',
  },
  foundingDate: '2019',
  googleVerification: 'xxx',
};
